// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/decompression-sickness.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/decompression-sickness/decompression-sickness.js';

mount([g0]);
